import React from 'react';

import styles from './gui-loading-fallback.css';

/**
 * Ecrã mostrado enquanto o chunk do editor (GUI/VM) é carregado após o login.
 */
export default function GuiLoadingFallback () {
    return (
        <div
            aria-busy="true"
            aria-live="polite"
            className={styles.wrap}
        >
            <div className={styles.card}>
                <div className={styles.spinner} />
                <p className={styles.text}>
                    {'A carregar o Labcode…'}
                </p>
            </div>
        </div>
    );
}
